/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useMediaQuery } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';
import { ProductsDetailsListColumnRendering } from './ProductsDetailsListColumnRendering';
import { ProductsDetailsListLineRendering } from './ProductsDetailsListLineRendering';
import { TProductDetails } from 'interfaces/challenge.types';

export interface IProductsProps {
  productDetailsList: TProductDetails[];
  rowsPerPage?: number;
  withHeaderFieldsDescription?: boolean;
  isGoalMecanicByProduct: boolean;
  displayFinancialValues: boolean;
  displayGainValues: boolean;
  unitToDisplay: string | null;
}
export const ProductsDetailsList = ({
  productDetailsList,
  rowsPerPage,
  isGoalMecanicByProduct,
  displayFinancialValues,
  displayGainValues = true,
  unitToDisplay,
}: IProductsProps): JSX.Element => {
  const isMobile = useMediaQuery((theme: ICustomTheme) =>
    theme.breakpoints.down('sm'),
  );

  return isMobile ? (
    <ProductsDetailsListColumnRendering
      productDetailsList={productDetailsList}
      rowsPerPage={rowsPerPage}
      isGoalMecanicByProduct={isGoalMecanicByProduct}
      displayFinancialValues={displayFinancialValues}
      displayGainValues={displayGainValues}
      unitToDisplay={unitToDisplay}
      withHeaderFieldsDescription
    />
  ) : (
    <ProductsDetailsListLineRendering
      rowsPerPage={rowsPerPage}
      productDetailsList={productDetailsList}
      isGoalMecanicByProduct={isGoalMecanicByProduct}
      displayFinancialValues={displayFinancialValues}
      displayGainValues={displayGainValues}
      unitToDisplay={unitToDisplay}
      withHeaderFieldsDescription
    />
  );
};
